module.exports = __webpack_public_path__ + "img/360-renare-rum.2e71216d.jpg";